import React, { createContext, ReactNode, useState, useContext } from 'react';

interface ZoomCoordinates {
  x1: Date;
  x2: Date;
}

interface ZoomContext {
  zoomed: boolean;
  zoomCoordinates?: ZoomCoordinates;
  zoomChart: (x1: Date, x2: Date) => void;
}

export const ZoomContext = createContext({} as ZoomContext);

interface Props {
  children: ReactNode;
}

export const ZoomProvider = (props: Props) => {
  const [zoomCoordinates, setZoomCoordinates] = useState<ZoomCoordinates>();
  const [zoomed, setZoomed] = useState(false);
  const zoomChart = (x1: Date, x2: Date) => {
    setZoomed(true);
    setZoomCoordinates({ x1, x2 });
  };
  return (
    <ZoomContext.Provider value={{ zoomCoordinates, zoomChart, zoomed }}>
      {props.children}
    </ZoomContext.Provider>
  );
};

export const useZoom = () => useContext(ZoomContext);
export default useZoom;
